import { render, staticRenderFns } from "./TermsCopy.vue?vue&type=template&id=615788f2&scoped=true&"
import script from "./TermsCopy.vue?vue&type=script&lang=js&"
export * from "./TermsCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615788f2",
  null
  
)

export default component.exports